/**
 * Item 3 (Jun-2026, User-Wunsch) — globaler Live-Listener für eingehende Anrufe.
 * Lauscht auf dem Nutzer-Websocket auf ``caller_incoming`` und zeigt einen
 * Screen-Pop mit dem Kundendossier.
 */
import { useState } from "react";
import { PhoneIncoming, X } from "lucide-react";
import useUserSocket from "../../lib/useUserSocket";
import CallerDossier from "./CallerDossier";

export default function CallerIdListener({ userId }) {
    const [call, setCall] = useState(null);

    useUserSocket(userId, (evt) => {
        if (evt?.type === "caller_incoming") setCall(evt);
    });

    if (!call) return null;
    return (
        <div className="fixed bottom-4 right-4 z-[100] w-[360px] max-w-[calc(100vw-2rem)] animate-in slide-in-from-bottom-4" data-testid="caller-screen-pop">
            <div className="bg-white border-2 border-indigo-500 rounded-sm shadow-2xl overflow-hidden">
                <div className="bg-indigo-600 text-white px-4 py-2.5 flex items-center justify-between">
                    <span className="flex items-center gap-2 font-bold text-sm">
                        <PhoneIncoming className="w-4 h-4 animate-pulse" /> Eingehender Anruf
                        {call.department_label && <span className="text-[10px] font-normal opacity-80">· {call.department_label}</span>}
                    </span>
                    <button onClick={() => setCall(null)} className="hover:bg-white/20 rounded p-0.5" data-testid="caller-pop-close"><X className="w-4 h-4" /></button>
                </div>
                <div className="p-3 max-h-[60vh] overflow-y-auto">
                    <div className="text-xs text-gray-500 mb-2 font-mono-num">{call.number}</div>
                    <CallerDossier dossier={call} compact />
                </div>
            </div>
        </div>
    );
}
